export default {
  header: 'Releases',
  empty: 'No releases in this period.',
  date: 'Date',
  product: 'Product',
  bottleSize: 'Bottle/can size',
  amount: 'Amount',
  batch: 'Batch',
  note: 'Note',
  excise: 'Excise to pay (€)',
  exciseStatus: 'Excise status',
  paidOn: 'Paid on',
  paymentRef: 'Payment ref',
  paid: 'Paid',
  unpaid: 'Unpaid',
};
